var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4444 0H2.55556C1.87778 0 1.22776 0.269245 0.748505 0.748505C0.269245 1.22776 0 1.87778 0 2.55556V20.4444C0 21.1222 0.269245 21.7722 0.748505 22.2515C1.22776 22.7308 1.87778 23 2.55556 23H20.4444C21.1222 23 21.7722 22.7308 22.2515 22.2515C22.7308 21.7722 23 21.1222 23 20.4444V2.55556C23 1.87778 22.7308 1.22776 22.2515 0.748505C21.7722 0.269245 21.1222 0 20.4444 0ZM20.4444 20.4444H2.55556V2.55556H20.4444V20.4444ZM7.66667 17.8889H5.11111V11.5H7.66667V17.8889ZM12.7778 17.8889H10.2222V8.94444H12.7778V17.8889ZM17.8889 17.8889H15.3333V5.11111H17.8889V17.8889Z",
    fill: "#FFB648"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.40f573a2d0957ed9af304316b8752bfe.svg";
export { ForwardRef as ReactComponent };